import { Injectable } from '@angular/core';
import { HttpService, ResponseType } from '@app/shared/services/http/http.service';
import { UrlService } from '@app/shared/services/url/url.service';
import { Observable } from 'rxjs';

export interface IFilterTimeline {
  startDate: string;
  endDate: string;
  idTrade?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TimelineService {
  constructor(private _urlService: UrlService, private _httpService: HttpService) {}

  timelineReport(data: IFilterTimeline, model: string) {
    const url = this._urlService.getUrl(model + '.getTimelineReport', { ...data });
    return this._httpService.get(url, null, ResponseType.ARRAYBUFFER);
  }
}
